module.exports = __webpack_public_path__ + "img/7.57901e63.png";